"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RedErrorMessageBox;
const react_1 = __importDefault(require("react"));
function RedErrorMessageBox({ children, }) {
    return (react_1.default.createElement("div", { style: {
            padding: 4,
            margin: 4,
            overflow: 'auto',
            maxHeight: 200,
            background: '#f88',
            border: '1px solid black',
        } }, children));
}
